<div class="flex flex-wrap-reverse sm:flex-nowrap items-center px-2 py-4 md:px-6 bg-neutral2">
    <app-header-name class="flex items-center h-fit w-full sm:w-fit"></app-header-name>
    <div class="flex items-center h-fit ml-auto">
        <app-workspace-controls class=""></app-workspace-controls>
        <app-search *appEnv="'prod'; visible: false" class="mx-6 xl:ml-4 sm:mr-5"></app-search>
        <app-notifications-menu *appEnv="'prod'; visible: false"></app-notifications-menu>
    </div>
</div>
